module.exports = __webpack_public_path__ + "img/bbu_3801.9b3d6877.png";